import { render, staticRenderFns } from "./MaterialLinks.vue?vue&type=template&id=e0e28448&"
import script from "./MaterialLinks.vue?vue&type=script&lang=js&"
export * from "./MaterialLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MaterialLink: require('/vercel/path0/components/cards/MaterialLink.vue').default,Accordion: require('/vercel/path0/components/general/Accordion.vue').default,Container: require('/vercel/path0/components/general/Container.vue').default,SelectableBgColor: require('/vercel/path0/components/general/SelectableBgColor.vue').default})
